//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum InputSources {
	None = 0,
	User = 1,
	ChatGPT = 2,
	Bedrock = 3
}
